export enum EntryCriteriaTypes {
  Field = 'FIELD',
  'Stage Of Record' = 'STATE OF RECORD',
  'State Of Related Objects' = 'STATE OF RELATED OBJECTS',
}
